import React, { Component } from 'react';
import {List,SearchBar, Flex, NavBar, Calendar, WingBlank, Tabs, Toast, WhiteSpace} from 'antd-mobile';
import df from 'dateformat'
import send from '../../../utils/send';
import _ from 'lodash'
import ListImg from "../../../components/ListImg";
const LABELS = {
  'F': '分娩',
  'M': '配种',
  'A': '返情/空怀',
  'G': '后备种猪',
  'TIN': '转入',
  'V': '选种',
  'W': '断奶',
  'D': '死亡',
  'CH': '转移',
  'C': '淘汰'
};

export default class SwineList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      type: 'male',
      showIndex: 0, //female
      tabs: [
        { title: '公猪',type:'male' },
        { title: '母猪',type:'female' },
        { title: '仔猪',type:'pig' },
        { title: '肥猪',type:'grower' }
      ],
      resData: {},
      male:[],
      female: [],
      pig: [],
      grower: []
    }
  }
  componentDidMount() {
    const _self = this;
    _self.listenScroll = _.debounce(function (k,v) {
      _self.setState(state => {
        state[k] = v;
        return state;
      })
    }, 100);
    _self.doSearchData = _.debounce(function (V) {
      _self.doSearch(V)
    }, 500);
    this.getData('female');
    this.getData('male');
    this.getData('pig');
    this.getData('grower')
  }
  getData = (type) => {
    send({
      url: `/api/forward/ifarm/simpleSwineManager/${type}`,
      method: 'get'
    }).then(res => {
      let success = res.status === 200 && (res.data.code*1) === 200;
      if(success) {
        this.setState(state => {
          state[type] = res.data.data;
          state.resData[type] = res.data.data;
          return state;
        })
      }

    })
  };
  doSearch = (v) => {
    const {resData,type} = this.state;
    console.log(type,v, resData);
    const femaleData = resData.female.filter(o => {
      let swineId = o.swineTrack.split('-')[3];
      return swineId.indexOf(v) >= 0
    });
    const maleData = resData.male.filter(o => {
      let swineId = o.swineTrack.split('-')[3];
      return swineId.indexOf(v) >= 0
    });
    console.log(femaleData);
    this.setState(state => {
      state.female = femaleData;
      state.male = maleData;
      return state
    })
  };
  renderList = data => {
    return data.map((o,index) =>
      <WingBlank size="md"
                 key={index}
      >
        <div className={'round-list'}>
          <List.Item>
            <span className={'text-3'}>{o.locationName}</span>
          </List.Item>
          <Flex justify={'between'}
                className={'bg-white'}
                style={{padding: '10px 15px'}}
          >
            <span>品种：<b>{o.breederName}</b></span>
            <span>周龄：<b>{o.weekAge}</b></span>
          </Flex>
          <Flex justify={'between'}
                className={'bg-white'}
                style={{padding: '10px 15px'}}
          >
            <span>数量：<b>{o.qty}</b>头</span>
            <span>饲养天数：<b>{o.feedDay}</b></span>
          </Flex>

        </div>
      </WingBlank>)
  };
  femaleNodes = (o, index) => {
    return <div className={'round-list'}>
      <List.Item extra={<span className={'active-text'}>{o.litno1}胎</span>}
      >
        <span className={'text-3'}>{o.swineTrack}</span>
      </List.Item>
      <Flex justify={'between'}
          className={'bg-white'}
          style={{padding: '10px 15px'}}
      >
        <span>品种：<b>{o.breederName}</b></span>
        <span>周龄：<b>{o.weekAge}</b></span>
      </Flex>
      <Flex justify={'between'}
          className={'bg-white'}
          style={{padding: '10px 15px'}}
      >
        <span>当前状态：<b>{LABELS[o['activityType']]}</b></span>
        <span>{LABELS[o['activityType']]}日期：<b>{o.activityDate ? df(o.activityDate, 'yyyy/mm/dd'):'-'}</b></span>
      </Flex>

    </div>
  };
  renderFemale = data => {
    const {showIndex} = this.state;
    console.log(showIndex,this.state.type,data);
    return data.map((o,index) =>
      <WingBlank size="md"
          key={index}
      >
        {
          (index >= (showIndex-10) && index <= (showIndex + 40)) ?
            this.femaleNodes(o, index):
            <div className={'round-list text-2'} style={{height: 116,textAlign: 'center'}}>...</div>
        }
      </WingBlank>)
  };
  renderMale = data => {
    return data.map((o,index) =>
      <WingBlank size="md"
          key={index}
      >
        <div className={'round-list'}>
          <List.Item>
            <span className={'text-3'}>{o.swineTrack}</span>
          </List.Item>
          <Flex justify={'between'}
              className={'bg-white'}
              style={{padding: '15px 15px'}}
          >
            <span>品种：<b>{o.breederName}</b></span>
            <span>周龄：<b>{o.weekAge}</b></span>
          </Flex>
        </div>
      </WingBlank>)
  };
  render() {
    const {tabs,female,male,pig,grower,type} = this.state;
    return (
      <React.Fragment>
        <SearchBar placeholder={'点击搜索猪只耳号'}
            onChange={v=>{
              this.doSearchData(v)
            }}
        />
        <Tabs tabs={tabs}
            swipeable={false}
            animated={false}
            initialPage={0}
            onChange={(tab, index) => {
                this.setState({
                  type: tab.type
                })
              }}
        >
          <div  style={{height: 'calc(100vh - 90px)',overflowY: 'scroll'}}>
            {
              (type === 'male' && male.length > 0) && this.renderMale(male)
            }
            {male.length === 0 && <ListImg height={100} />}
          </div>
          <div style={{height: 'calc(100vh - 90px)',overflowY: 'scroll'}}
              onScroll={(v) => {
                let showIndex = Math.floor((v.target.scrollTop) / 126);
                this.listenScroll('showIndex',showIndex)
          }}
          >
            {
              (type === 'female' && female.length > 0) && this.renderFemale(female)
            }
            {female.length === 0 && <ListImg height={100} />}
          </div>
          <div  style={{height: 'calc(100vh - 90px)',overflowY: 'scroll'}}>
            {
              (type === 'pig' && pig.length > 0) && this.renderList(pig)
            }
            {pig.length === 0 && <ListImg height={100} />}
          </div>
          <div  style={{height: 'calc(100vh - 90px)',overflowY: 'scroll'}}>
            {
              (type === 'grower' && grower.length > 0) && this.renderList(grower)
            }
            {grower.length === 0 && <ListImg height={100} />}
          </div>
        </Tabs>
      </React.Fragment>
    )
  }
}
